<template>
    <div class="col-12 col-lg-4 dashboard__box-col">
        <div :class="['box ', color]">
          <div v-bind:class="{pending: pending}">
            <h2 class="h h--2">Wydarzenia stacjonarne</h2>
            <p>Sprawdź nadchodzące wydarzenia i zapisz się za pomocą jednego kliknięcia.</p>
            <div v-for="training in trainings" :key="training.id">
              <h3 class="dashboard__points">
                  {{ training.start_time | formatDate('DD.MM.YYYY') }} <span>{{ training.address.city }}</span>
              </h3>
              <!-- <a class="button button__bottom" @click.prevent="enroll(training.id)">Zapisz się &raquo;</a> -->
            </div>
            <router-link :to="{name: 'StationaryTraining'}" class="button button__bottom">Zobacz listę &raquo;</router-link>
          </div>
        </div>
    </div>
</template>


<script>
import Vue from 'vue'

export default {
  name: 'TrainingWidget',
  props: {
    color: {
        default: 'box--green'
    }
  },
  data () {
    return {
        pending: true,
        trainings: []
    }
  },
  created() {
    let vm = this;

    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();

    today = yyyy + "-" + mm + '-' + dd;

    Vue.axios({
      method: 'get',
      url: '/events',
      params: {
        event_types: [1],
        pagination: 1,
        from_end_date: today
      }
    })
    .then(response => {
      vm.pending = false
      vm.trainings = response.data.data.events
    })
    .catch(error => {
      vm.pending = false
    })
  },
  methods: {
      enroll: function(event_id) {
        Vue.axios({
            method: 'post',
            url: '/events/participate/' + event_id
        })
        .then(response => {
            this.$toaster.success(response.data.message)
        })
        .catch(error => {
            this.$toaster.error(error.response.data.message)
        })
      }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/home/training/TrainingWidget.vue